import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import colors from '../../../utils/colors';
import { GroupInput, Button, Icon } from '../../../components';
import { getPDF } from '../../../redux/actions';

function PrintModalLayout() {
	const user = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const activeTest = useSelector((state) => state.editor.test);

	const [groupCount, setGroupCount] = useState(1);
	const [isLoading, setLoading] = useState(null);

	const handlePrint = (fileType) => {
		setLoading(fileType);
		dispatch(getPDF(activeTest, user.id, groupCount, fileType, () => {
			setLoading(null);
		}));
	};

	const testTime = Math.ceil(
		activeTest.tasks.map((task) => Number(task['czas_odp'])).reduce((a, b) => a + b)
	);

	return (
		<div className="print-settings-modal">
			<h3>Ustawienia drukowania</h3>
			<ul>
				<li>
					<span>nazwa testu</span>
					<span>{activeTest.nazwa}</span>
				</li>
				<li>
					<span>liczba zadań</span>
					<span>{activeTest['liczba_pytan']}</span>
				</li>
				<li>
					<span>grupy</span>
					<GroupInput
						label=""
						value={groupCount}
						min={1}
						max={16}
						onChange={setGroupCount}
						mobile
					/>
				</li>
				<li>
					<span>czas trwania testu</span>
					<span>{`${testTime} minut`}</span>
				</li>
			</ul>
			<div className="print-buttons">
				<Button
					color="primary text-white"
					className={isLoading === 'test' ? ' disabled' : ''}
					onClick={() => handlePrint('test')}
				>
					pobierz i drukuj test
					{isLoading === 'test' ? (
						<Icon name="spinner" width="13" height="13" />
					) : (
						<Icon name="print" width="15" height="15" color={colors.white} />
					)}
				</Button>
				<Button
					color="secondary text-white"
					className={isLoading === 'key' ? ' disabled' : ''}
					onClick={() => handlePrint('key')}
				>
					pobierz i wydrukuj klucz odpowiedzi
					{isLoading === 'key' ? (
						<Icon name="spinner" width="13" height="13" />
					) : (
						<Icon name="print" width="15" height="15" color={colors.white} />
					)}
				</Button>
			</div>
		</div>
	);
}

export default PrintModalLayout;
